<div
  class="variable-element d-flex justify-content-between align-items-center bg-light border tw-border-gray-200 rounded-3 p-3 position-relative z-3 max-height-45"
  [ngClass]="[!selectedTemplate ? 'opacity-40 cursor-default' : 'cursor-grab']"
  cdkDrag
  (cdkDragDropped)="onElementDrop($event)"
  (cdkDragMoved)="onElementMove($event)"
  (cdkDragStarted)="onElementDragStart()"
  cdkDragBoundary=".badge-template__container"
>
  <div *cdkDragPlaceholder class="opacity-40">
    <app-variable-element [variableElement]="variableElement"></app-variable-element>
  </div>
  <div class="d-flex gap-2 align-items-center">
    <svg class="tw-min-w-3" width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.64625 4.20943C3.64674 4.20943 4.45779 3.41695 4.45779 2.43937C4.45779 1.46179 3.64674 0.669312 2.64625 0.669312C1.64577 0.669312 0.834717 1.46179 0.834717 2.43937C0.834717 3.41695 1.64577 4.20943 2.64625 4.20943Z"
        fill="#9CA3AF"
      />
      <path
        d="M2.64625 10.2712C3.64674 10.2712 4.45779 9.47872 4.45779 8.50114C4.45779 7.52356 3.64674 6.73108 2.64625 6.73108C1.64577 6.73108 0.834717 7.52356 0.834717 8.50114C0.834717 9.47872 1.64577 10.2712 2.64625 10.2712Z"
        fill="#9CA3AF"
      />
      <path
        d="M2.64625 16.333C3.64674 16.333 4.45779 15.5405 4.45779 14.5629C4.45779 13.5853 3.64674 12.7928 2.64625 12.7928C1.64577 12.7928 0.834717 13.5853 0.834717 14.5629C0.834717 15.5405 1.64577 16.333 2.64625 16.333Z"
        fill="#9CA3AF"
      />
      <path
        d="M9.34604 4.20943C10.3465 4.20943 11.1576 3.41695 11.1576 2.43937C11.1576 1.46179 10.3465 0.669312 9.34604 0.669312C8.34556 0.669312 7.5345 1.46179 7.5345 2.43937C7.5345 3.41695 8.34556 4.20943 9.34604 4.20943Z"
        fill="#9CA3AF"
      />
      <path
        d="M9.34604 10.2712C10.3465 10.2712 11.1576 9.47872 11.1576 8.50114C11.1576 7.52356 10.3465 6.73108 9.34604 6.73108C8.34556 6.73108 7.5345 7.52356 7.5345 8.50114C7.5345 9.47872 8.34556 10.2712 9.34604 10.2712Z"
        fill="#9CA3AF"
      />
      <path
        d="M9.34604 16.333C10.3465 16.333 11.1576 15.5405 11.1576 14.5629C11.1576 13.5853 10.3465 12.7928 9.34604 12.7928C8.34556 12.7928 7.5345 13.5853 7.5345 14.5629C7.5345 15.5405 8.34556 16.333 9.34604 16.333Z"
        fill="#9CA3AF"
      />
    </svg>
    <div class="tw-w-5 tw-h-5 tw-min-w-5 tw-flex tw-justify-center tw-items-center" *ngIf="variableElement?.icon" [innerHTML]="variableElement.icon | safe"></div>
    <p class="fw-medium m-0 text-sm text-dark">
      {{ variableElementLabel }}
    </p>
  </div>
</div>
